import * as React from 'react';

export const ContentKitBuilderScreen = React.lazy(() => import('./ContentKitBuilderScreen'));
